/** Colunas do order by da pesquisa dos recursos de campanhas */
export enum RecursoCampanhaSearchOrderBy {
    Codigo = 1,
    Nome = 2,
    Tipo = 3,
    NomeArea = 4,
    Situacao = 5
};
